var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "db-col-select",
      staticStyle: { width: "100%", height: "100%" }
    },
    [
      _c(
        "el-table",
        {
          ref: "the-table",
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.colMetaList,
            border: "",
            height: _vm.tableHeight,
            stripe: "",
            border: "",
            "row-key": "columnName",
            "row-class-name": _vm.getTableRowClassName
          },
          on: { "row-dblclick": _vm.handleDblClickRow }
        },
        [
          _c("el-table-column", {
            attrs: {
              width: "40",
              label: "选择",
              fixed: "",
              selectable: _vm.isRowSelectable,
              type: "selection"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "60", label: "序号", align: "right" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [_c("span", [_vm._v(_vm._s(rows.row.ordinal))])]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: { width: "200", label: "列名称", align: "left" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(rows) {
                  return [
                    rows.row.columnPk
                      ? _c(
                          "span",
                          {
                            staticStyle: {
                              "font-weight": "bold",
                              color: "navy"
                            },
                            attrs: { title: "主键" }
                          },
                          [_vm._v(_vm._s(rows.row.columnName))]
                        )
                      : _c("span", [_vm._v(_vm._s(rows.row.columnName))])
                  ]
                }
              }
            ])
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "200",
              prop: "comment",
              label: "列备注",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "100",
              prop: "sqlType",
              label: "sql类型",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "160",
              prop: "javaType",
              label: "java类型",
              align: "left"
            }
          }),
          _vm._v(" "),
          _c("el-table-column", {
            attrs: {
              width: "80",
              prop: "charMaxLength",
              label: "字符宽度",
              align: "right"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3c24d850", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c24d850","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/query/DbColSelect.vue
// module id = 1665
// module chunks = 1